
namespace RioERP.Reports {
    export class ReferralOrderProductsColumns {
        static columnsKey = 'Reports.ReferralOrderProducts';
    }
}